import { get, values } from 'lodash';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import JobRequestTable from '../../../../../../common/components/JobRequestTable';

import * as adminStore from '../../../../../../redux/actionCreators/sync/index';
import * as jobRequestApi from '../../../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../../../redux/actionCreators/sync/jobrequests';

@connect((store, props) => {
  const companyId = parseInt(props.params.companyId, 10) || 0;
  const staticData = store.staticData;
  const contacts = store.companyContacts;
  const filters = store.admin.jobRequests.filters;
  const searchTerms = store.admin.jobRequests.searchTerms;

  return {
    companyId,
    staticData,
    contacts,
    filters,
    searchTerms,
    jobRequests: store.companyJobRequests
  };
})
export default class JobRequestPanel extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      contacts: get(props, 'contacts', [])
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.contacts) {
      this.setState({contacts: nextProps.contacts});
    }
  }

  onJobRequestFilterChange = (filters = {}) => {
    this.props.dispatch(adminStore.updateJobRequestFilters(filters));
  }

  onJobRequestTermsChange = (terms = []) => {
    this.props.dispatch(adminStore.updateJobRequestTerms(terms));
  }

  fetchJobRequests(filters = {}, terms = [], skip) {
    const callbacks = {
      success: (items) => this.props.dispatch(jobRequestStore.updateCompanyJobRequests(items)),
      error: (err) => console.error('updateCompanyJobRequests failed', err),
    };

    this.props.dispatch(jobRequestApi.getAllJobs(
       callbacks,
       skip,
       terms,
       filters,
       this.props.companyId
    ));
   }


  render() {
    return (
      <JobRequestTable
        columns={['Id', 'Date', 'Title', 'Openings', 'Contact', 'Status']}
        onJobRequestFilterChange={this.onJobRequestFilterChange}
        onJobRequestTermsChange={this.onJobRequestTermsChange}
        fetchJobs={::this.fetchJobRequests}
        jobRequestsList={values(this.props.jobRequests)}
        filters={this.props.filters}
        searchTerms={this.props.searchTerms}
        contacts={this.state.contacts}
        showHeader={false}
        JobRequestsTable={false}
        showLink={false}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Content/JobRequests/index.js